<div class="flex flex-col gap-6 p-6 bg-gray-50 min-h-screen">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <p-card class="!bg-green-800">
      <ng-icon name="hugeFlash" class="text-white text-4xl mb-2" />
      <div class="flex flex-col gap-1">
        <div class="text-white text-xs uppercase tracking-wide">
          Total Energía
        </div>
        <div class="text-3xl font-semibold text-white">
          {{ summary().energy_kwh | number: "1.1-1" }} MWh
        </div>
      </div>
    </p-card>

    <p-card>
      <ng-icon name="hugeTimer02" class="text-yellow-900 text-4xl mb-2" />
      <div class="flex flex-col gap-1">
        <div class="text-gray-600 text-xs uppercase tracking-wide">
          Tiempo Total de Carga
        </div>
        <div class="text-3xl font-semibold">
          {{ summary().usage_seconds | timeFormat: false : false : true }}
        </div>
      </div>
    </p-card>

    <p-card>
      <ng-icon name="hugeEvCharging" class="text-green-900 text-4xl mb-2" />
      <div class="flex flex-col gap-1">
        <div class="text-gray-600 text-xs uppercase tracking-wide">
          Total de Cargas
        </div>
        <div class="text-3xl font-semibold">
          {{ summary().sessions_count }} cargas
        </div>
      </div>
    </p-card>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
    <div class="flex flex-col gap-2">
      <label for="range_dates" class="text-sm">Período</label>
      <p-datepicker
        inputId="range_dates"
        [(ngModel)]="rangeDates"
        (ngModelChange)="handleFilterChange('range_dates', $event)"
        selectionMode="range"
        [readonlyInput]="true"
        dateFormat="dd/mm/yy"
        size="small"
        placeholder="Seleccione el rango"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="company_id" class="text-sm">Empresa</label>
      <p-select
        inputId="company_id"
        [options]="companiesOpts"
        [(ngModel)]="selectedCompany"
        (ngModelChange)="handleFilterChange('company_id', $event)"
        (onChange)="loadStations($event.value)"
        size="small"
        [showClear]="true"
        placeholder="Seleccionar empresa..."
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="station_id" class="text-sm">Estación</label>
      <p-select
        inputId="station_id"
        [options]="stationsOpts"
        [(ngModel)]="selectedStation"
        (ngModelChange)="handleFilterChange('station_id', $event)"
        size="small"
        [showClear]="true"
        placeholder="Todas"
      />
    </div>
  </div>

  <p-card class="stats-card" [style]="{ overflow: 'hidden' }">
    <ng-template #header>
      <div class="flex items-center justify-between flex-shrink-0 gap-4">
        <h2 class="text-lg font-semibold text-gray-800">
          Análisis de disponibilidad y rendimiento
        </h2>
        <p-paginator
          [first]="(meta().page - 1) * meta().per_page"
          [rows]="meta().per_page"
          [totalRecords]="meta().total_items"
          (onPageChange)="handlePageChange($event)"
          [rowsPerPageOptions]="[10, 20, 50, 100]"
          [showFirstLastIcon]="true"
        />
      </div>
    </ng-template>
    <p-table
      [value]="stations()"
      class="text-sm"
      selectionMode="single"
      [(selection)]="station"
      [loading]="loadingStationAP()"
      (onRowSelect)="handlerOnRowSelect($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>ESTACIÓN</th>
          <th>% DISPONIBILIDAD</th>
          <th>% DE USO</th>
          <th class="!text-center">FUERA DE LÍNEA</th>
          <th>CARGAS</th>
          <th>ENERGÍA (KWH)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-station>
        <tr [pSelectableRow]="station">
          <td>{{ station.name }}</td>
          <td>
            <app-circular-progress
              [value]="station.availability_pct"
              fill="#10b981"
            />
          </td>
          <td>
            <app-circular-progress [value]="station.usage_pct" fill="#f59e0b" />
          </td>
          <td class="!text-center">
            {{
              station.offline_seconds | timeFormat: true : false : false : "h"
            }}
          </td>
          <td>{{ station.sessions_count }}</td>
          <td>{{ station.energy_kwh | number: "1.1-1" }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">
            <div class="flex flex-col items-center justify-center gap-2 py-6 text-gray-400">
              <i class="pi pi-inbox !text-3xl"></i>
              <p class="text-sm">No hay resultados para mostrar</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  @if (station()) {
    <p-card class="stats-card" [style]="{ overflow: 'hidden' }">
      <ng-template #header>
        <div class="flex items-center justify-between flex-shrink-0 gap-4">
          <h2 class="text-lg font-semibold text-gray-800">
            Análisis de disponibilidad y rendimiento ({{ stationName() }})
          </h2>
        </div>
      </ng-template>
      <p-table
        [value]="chargers()"
        class="text-sm"
        [loading]="loadingAllData()"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>CARGADOR</th>
            <th>% DISPONIBILIDAD</th>
            <th>% DE USO</th>
            <th class="!text-center">FUERA DE LÍNEA</th>
            <th>CARGAS</th>
            <th>ENERGÍA (KWH)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-charger>
          <tr>
            <td>{{ charger.charger_code }}</td>
            <td>
              <app-circular-progress
                [value]="charger.availability_pct"
                fill="#10b981"
              />
            </td>
            <td>
              <app-circular-progress
                [value]="charger.usage_pct"
                fill="#f59e0b"
              />
            </td>
            <td class="!text-center">
              {{ charger.offline_seconds | timeFormat: true : false : false : "h" }}
            </td>
            <td>{{ charger.sessions_count }}</td>
            <td>{{ charger.energy_kwh | number: "1.1-1" }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">
              <div class="flex flex-col items-center justify-center gap-2 py-6 text-gray-400">
                <i class="pi pi-inbox !text-3xl"></i>
                <p class="text-sm">No hay resultados para mostrar</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <p-card class="stats-card" [style]="{ overflow: 'hidden' }">
      <ng-template #header>
        <div class="flex items-center justify-between flex-shrink-0 gap-4">
          <h2 class="text-lg font-semibold text-gray-800">
            Uso por tipo de conector ({{ stationName() }})
          </h2>
        </div>
      </ng-template>
      <p-table
        [value]="connectorTypes()"
        class="text-sm"
        [loading]="loadingAllData()"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%">CARGADOR</th>
            <th style="width: 15%">TIPO CONECTOR</th>
            <th style="width: 15%">TOTAL ENERGÍA (EST)</th>
            <th style="width: 15%">ENERGÍA (KWH)</th>
            <th style="width: 15%" class="!text-center">TIEMPO DE USO</th>
            <th style="width: 20%">% CARGA</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-connectorType>
          <tr>
            <td>{{ connectorType.charger_code }}</td>
            <td>
              <p-tag
                severity="info"
                [value]="connectorType.code"
                [rounded]="true"
                class="!text-xs"
              />
            </td>
            <td>{{ connectorType.total_energy_kwh | number: "1.1-1" }}</td>
            <td>{{ connectorType.energy_kwh | number: "1.1-1" }}</td>
            <td class="!text-center">
              {{ connectorType.usage_seconds | timeFormat: true : false : false : "h" }}
            </td>
            <td>
              @let usagePercentage = connectorType.charge_pct;
              <div class="flex items-center gap-2">
                <p-progressbar
                  [showValue]="false"
                  [value]="usagePercentage"
                  [style]="{ height: '10px', display: 'flex', flex: '1' }"
                />
                <span class="text-xs font-semibold">
                  {{ usagePercentage }}%
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">
              <div class="flex flex-col items-center justify-center gap-2 py-6 text-gray-400">
                <i class="pi pi-inbox !text-3xl"></i>
                <p class="text-sm">No hay resultados para mostrar</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <p-card class="stats-card" [style]="{ overflow: 'hidden' }">
      <ng-template #header>
        <div class="flex items-center justify-between flex-shrink-0 gap-4">
          <h2 class="text-lg font-semibold text-gray-800">
            Detalle de uso por conector ({{ stationName() }})
          </h2>
        </div>
      </ng-template>
      <p-table
        [value]="connectors()"
        class="text-sm"
        [loading]="loadingAllData()"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%">CARGADOR</th>
            <th style="width: 15%">ID CONECTOR</th>
            <th style="width: 15%">TOTAL ENERGÍA</th>
            <th style="width: 15%">ENERGÍA (KWH)</th>
            <th style="width: 15%" class="!text-center">TIEMPO DE USO</th>
            <th style="width: 20%">% CARGA</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-connector>
          <tr>
            <td>{{ connector.charger_code }}</td>
            <td>{{ connector.code }}</td>
            <td>{{ connector.total_energy_kwh | number: "1.1-1" }}</td>
            <td>{{ connector.energy_kwh | number: "1.1-1" }}</td>
            <td class="!text-center">
              {{ connector.usage_seconds | timeFormat: true : false : false : "h" }}
            </td>
            <td>
              @let usagePercentage = connector.charge_pct;
              <div class="flex items-center gap-2">
                <p-progressbar
                  [showValue]="false"
                  [value]="usagePercentage"
                  [style]="{ height: '10px', display: 'flex', flex: '1' }"
                />
                <span class="text-xs font-semibold">
                  {{ usagePercentage }}%
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">
              <div class="flex flex-col items-center justify-center gap-2 py-6 text-gray-400">
                <i class="pi pi-inbox !text-3xl"></i>
                <p class="text-sm">No hay resultados para mostrar</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</div>
